
import { Heading3, Heading4 } from "@/components/layout";
import { useOnScrollTransition } from "@/hooks";
import { SkillArticleDto } from "@/types";
import { defineComponent, PropType, ref } from "vue";
import { Skill } from ".";

export default defineComponent({
  name: "SkillArticle",
  components: { Heading3, Heading4, Skill },
  props: {
    article: {
      type: Object as PropType<SkillArticleDto>,
    },
  },
  setup() {
    const skills = ref([]);

    useOnScrollTransition(skills, "animate-scroll-top");

    return { skills };
  },
});
